// src/pages/consult/step5/JURIDICO/SP/juridico.js
import React, { useState, useContext } from 'react';
import AuthContext from '../../../../../context/Auth/AuthContext';
import AuthService from '../../../../../services/AuthService';
import { useNavigate } from 'react-router-dom';
import styles from '../../formJ.module.css';

const FormSPJuridico = ({ certificadosSelecionados, onBack }) => {
    const { user, setUser } = useContext(AuthContext);
    const [nomeEmpresa, setNomeEmpresa] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [cep, setCep] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState(false);
    const navigate = useNavigate();

    // Função para formatar o CNPJ
    const formatCNPJ = (value) => {
        value = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
        value = value.slice(0, 14); // Limita o CNPJ a 14 caracteres
        value = value.replace(/^(\d{2})(\d)/, '$1.$2'); // Adiciona o primeiro ponto
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); // Adiciona o segundo ponto
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2'); // Adiciona a barra
        value = value.replace(/(\d{4})(\d)/, '$1-$2'); // Adiciona o hífen
        return value;
    };

    // Função de validação do CNPJ (somente números)
    const validarCNPJ = (cnpj) => {
        const regex = /^\d{14}$/;  // Verifica se o CNPJ tem 14 dígitos
        return regex.test(cnpj.replace(/\D/g, '')); // Remove os caracteres não numéricos para validar
    };

    const certificados = certificadosSelecionados.flatMap(certificado => ({
        regiao: certificado.estado,
        model_id: certificado.certidao_id
    }));

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!nomeEmpresa || !validarCNPJ(cnpj)) {
            setErrorMessage('Preencha todos os campos obrigatórios e certifique-se de que o CNPJ é válido.');
            return;
        }

        const formData = {
            determination: certificados,
            tipo_pessoa: 'J',
            user_id: user?.user?.id,
            nome_empresa: nomeEmpresa,
            cnpj: cnpj.replace(/\D/g, ''),
            logradouro,
            numero,
            complemento,
            bairro,
            cidade,
            cep
        };

        try {
            console.log('Tentando enviar o formulário...');
            const response = await AuthService.enviarFormularioSP(formData);
            console.log('Formulário enviado com sucesso:', response.data);
        
            // Exibe o modal de sucesso
            setSuccessMessage(true);
            setTimeout(() => {
                setSuccessMessage(false);
                // Redireciona para o dashboard
                navigate('/home/dashboard');
            }, 3000); // 5 segundos de exibição
        } catch (error) {
            setErrorMessage('Erro ao enviar o formulário: ' + error.message);
        
            // Mesmo em caso de erro, exibe o modal e redireciona
            setSuccessMessage(true);
            setTimeout(() => {
                setSuccessMessage(false);
                // Redireciona para o dashboard
                navigate('/home/dashboard');
            }, 3000); // 5 segundos de exibição
        }
    };

    return (
        <div className={styles.formContainer}>
            <h4>Formulário Pessoa Jurídica</h4>
            <form onSubmit={handleSubmit}>
                
                {/* Nome da Empresa e CNPJ */}
                <div className={styles.formGroup}>
                    <div className={styles.halfWidth}>
                        <label htmlFor="nomeEmpresa"></label>
                        <input
                            type="text"
                            id="nomeEmpresa"
                            value={nomeEmpresa}
                            onChange={(e) => setNomeEmpresa(e.target.value)}
                            placeholder="Digite o nome da empresa"
                            required
                        />
                    </div>

                    <div className={styles.halfWidth}>
                        <label htmlFor="cnpj"></label>
                        <input
                            type="text"
                            id="cnpj"
                            value={cnpj}
                            onChange={(e) => setCnpj(formatCNPJ(e.target.value))}  // Aplica a formatação
                            placeholder="Digite o CNPJ"
                            maxLength={18}  // Máximo de 18 caracteres para exibir a máscara completa
                            required
                        />
                    </div>
                </div>

                {/* Logradouro, Número e Complemento */}
                <div className={styles.formGroup}>
                    <div className={styles.halfWidth}>
                        <label htmlFor="logradouro"></label>
                        <input
                            type="text"
                            id="logradouro"
                            value={logradouro}
                            onChange={(e) => setLogradouro(e.target.value)}
                            placeholder="Digite o logradouro"
                        />
                    </div>

                    <div className={styles.quarterWidth}>
                        <label htmlFor="numero"></label>
                        <input
                            type="text"
                            id="numero"
                            value={numero}
                            onChange={(e) => setNumero(e.target.value)}
                            placeholder="Digite o número"
                        />
                    </div>

                    <div className={styles.quarterWidth}>
                        <label htmlFor="complemento"></label>
                        <input
                            type="text"
                            id="complemento"
                            value={complemento}
                            onChange={(e) => setComplemento(e.target.value)}
                            placeholder="Digite o complemento"
                        />
                    </div>
                </div>

                {/* Bairro, Cidade e CEP */}
                <div className={styles.formGroup}>
                    <div className={styles.thirdWidth}>
                        <label htmlFor="bairro"></label>
                        <input
                            type="text"
                            id="bairro"
                            value={bairro}
                            onChange={(e) => setBairro(e.target.value)}
                            placeholder="Digite o bairro"
                        />
                    </div>

                    <div className={styles.thirdWidth}>
                        <label htmlFor="cidade"></label>
                        <input
                            type="text"
                            id="cidade"
                            value={cidade}
                            onChange={(e) => setCidade(e.target.value)}
                            placeholder="Digite a cidade"
                        />
                    </div>

                    <div className={styles.thirdWidth}>
                        <label htmlFor="cep"></label>
                        <input
                            type="text"
                            id="cep"
                            value={cep}
                            onChange={(e) => setCep(e.target.value)}
                            placeholder="Digite o CEP"
                        />
                    </div>
                </div>

                {/* Exibe a mensagem de erro, se houver */}
                {/*errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>*/}

                {/* Botão de Enviar */}
                <button type="submit">Enviar</button>
            </form>

            {successMessage && (
                <div className={styles.modal}>
                    <div className={styles.modalContent}>
                        <p>Solicitado com sucesso!</p>
                    </div>
                </div>
            )}

        </div>
    );
};

export default FormSPJuridico;
